import CryptoJS from 'crypto-js';

class EncrDecrService {
  
  // Method for encrypting the value
  set(value) {
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key, {
      iv: iv
    });

    return encrypted.toString();
  }

  // Method for decrypting the value
  get(value) {
    const key = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const iv = CryptoJS.enc.Hex.parse('0123456789abcdef0123456789abcdef');
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      iv: iv
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}

export default new EncrDecrService();
